export interface Claims {
  [name: string]: string | number | boolean | string[];
}

export interface UserInfo {
  bbUserName: string;
  isSuperUser: boolean;
  idpAvatar?: string;
}

export function getBbUserName(claims: Claims): string | undefined {
  return (
    (typeof claims.email === 'string' && claims.email.split('@')[0]) ||
    (typeof claims['cognito:username'] === 'string'
      ? claims['cognito:username']
      : undefined)
  );
}

export function getUserInfo(claims: Claims): UserInfo {
  const bbUserName = getBbUserName(claims) ?? '';
  const idpAvatar =
    typeof claims.picture === 'string' ? claims.picture : undefined;
  return {
    bbUserName,
    idpAvatar,
    isSuperUser: bbUserName === 'davids',
  };
}
